<template>
  <section>
    <v-dialog
      v-model="isShow"
      width="400px"
      @closed="closed">
      <div class="dialog-container">
        <div class="dialog-header">
          <span>Edit Description</span>
          <font-awesome-icon
            icon="times"
            class="pointer"
            @click="handleCancel"></font-awesome-icon>
        </div>
        <div class="dialog-body">
          <el-form
            ref="form"
            :model="formData"
            :rules="rules">
            <div class="info">
              <span class="title">Description</span>
              <el-form-item prop="description">
                <v-input
                  v-model="formData.description"
                  :rows="5"
                  type="textarea"></v-input>
              </el-form-item>
            </div>
          </el-form>
        </div>
        <div class="dialog-footer">
          <v-button
            gray
            @click="handleCancel">Cancel</v-button>
          <v-button
            green
            @click="handleSave">Save</v-button>
        </div>
      </div>
    </v-dialog>
  </section>
</template>

<script>
import {addDescription} from '@/api/account'
export default {
  name: 'EditDescription',
  props:{
    customerId:{
      type: [String, Number],
      default: ''
    },
    detailData:{
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      isShow: false,
      formData:{
        description: ''
      },
      rules:{
        description: [
          // {required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur']}
        ]
      }
    }
  },
  watch:{
    'detailData.description':{
      immediate: true,
      handler(val){
        if(val){
          this.formData.description = val
        }
      }
    },
    isShow:{
      immediate:true,
      handler(val){
        if(val){
          let {description} = this.detailData||{}
          this.formData.description = description
        }

      }
    }
  },
  methods: {
    changeDialog(){
      this.isShow = !this.isShow
    },
    handleCancel(){
      this.isShow = false
    },
    handleSave(){
      this.$refs['form'].validate(valid => {
        if(valid){
          this.network().addDescription()
        }
      })
    },
    closed(){
      this.$refs['form'].resetFields()
    },
    network(){
      return {
        addDescription: async () => {
          const {data} = await addDescription({
            customer_id: this.customerId,
            description: this.formData.description
          })
          if(data.code == 1000){
            this.$message({
              type: 'success',
              message: 'Success'
            })
            this.handleCancel()
            this.$emit('update')
          }
        }
      }
    }
  },
}
</script>
<style lang='scss' scoped>
  /deep/.el-dialog{
    box-sizing: border-box;
    border-radius: 6px;
  }
  .dialog-container {
    .dialog-header {
      padding: 16px;
      background: #F6F8FA;
      border-bottom: 1px solid #E1E4E8;
      border-radius: 6px 6px 0 0;
      display: flex;
      justify-content: space-between;
      span{
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 20px;
        display: flex;
        align-items: center;
        color: #1B1F23;
        flex: none;
        order: 0;
        align-self: stretch;
        flex-grow: 0;
      }
    }
    .dialog-body{
      padding: 20px 15px;
      .info{
        .title{
          font-weight: 600;
          font-size: 14px;
          color: #24292E;
        }
      }
    }
    .dialog-footer {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 15px;
      padding-top: 0;
    }
  }
</style>
